import React from 'react';
import { useAuth } from '../AuthContext';
import LoggedInHome from '../components/home/LoggedInHome';
import LoggedOutHome from '../components/home/LoggedOutHome';
import '../components/home/AdaptiveHome.css';

const AdaptiveHome = () => {
  const { currentUser, userProfile } = useAuth();

  return (
    <div className="adaptive-home">
      {(currentUser || userProfile) ? <LoggedInHome /> : <LoggedOutHome />}
    </div>
  );
};

export default AdaptiveHome;
